import _ from "lodash"
import Client from "data/_client"
import { ImmutableBehaviorSubject as BehaviorSubject } from "data/lib/immutable-behavior-subject"
import { propertyHasErrors } from 'data/lib/validation'
import { logEvent } from 'data/lib/log-event'
import notificationService from 'data/notification'

// private module logic //

interface ExportObj {
  exportConfirmVisible: boolean,
  loading: boolean,
  propsWithErrors: object[]|null
}

const initialState = {
  exportConfirmVisible: false,
  exportType: null,
  loading: false,
  propsWithErrors: null,
  template: null
}

const host = process.env.IMPORT_API;
const exportStream = new BehaviorSubject<ExportObj>(initialState);

function biDataExport(payload:object){
  return Client.post(`report/request_bi_export`, payload)
  .then((message) => {
    if (message && message === 'message accepted'){
      notificationService.notify({
        type: "info",
        message: "BI Data Export Started",
        dismiss: 3000
      })
    }
  })
  .catch((err: { message: string }) => {
    return err
  })
}

function getBIDataExports():any{
  return Client.get(`dataexport?order=requeststart.desc&exporttype=eq.bidataexport`)
}

function exportFile(template:string, properties:object[]|undefined|null, chartid:string|null):void {
  const isFolder  = window.location.pathname.includes("/folder");
  const folderId  = isFolder ? _.last(JSON.parse(localStorage.folderPath)) : null

  exportStream.next({
    exportConfirmVisible: false,
    loading: true,
    propsWithErrors: null
  });

  if (isFolder && folderId){
    let propHasErrors:boolean = false;
    let propsWithErrors:Object[] = [];
    properties!.map(prop => {
      propHasErrors = propertyHasErrors(prop);
      if(propHasErrors) {
        propsWithErrors.push(prop);
      }
    });
    if(propsWithErrors.length) {
      exportStream.next({
        exportConfirmVisible: true,
        loading: false,
        propsWithErrors
      });
    } else {
      exportFileCb(template, chartid || null);
    }
  } else {
    exportFileCb(template, chartid || null);
  }
}

function exportFileCb(template:string, chartid:string|null):void {
  exportStream.next({
    exportConfirmVisible: false,
    loading: true,
    propsWithErrors: null
  });

  if (chartid){
    const exportRoute = `export/${template}?chartid=${chartid}`
    logEvent(`export-asset-management-${template}`, {source: {chartid: +chartid}})
    .then(() => Client.get(exportRoute, {host}))
    .then((res)=>{
      loadTemplate(res.data, template);
      cancelExport();
    });
  } else {
    const isFolder  = window.location.pathname.includes("/folder");
    const folderId  = _.last(JSON.parse(localStorage.folderPath));
    const currentId = isFolder ? folderId : localStorage.getItem('property');
    const exportRoute = isFolder ? `export/${template}?folderid=${currentId}` : `export/${template}?propertyid=${currentId}`

    const source = {[isFolder ? 'folderid' : 'propertyid']: currentId}
    logEvent(`export-${isFolder ? 'folder' : 'property'}-${template}`, {source})
    .then(() => Client.get(exportRoute, {host}))
    .then((res)=>{
      loadTemplate(res.data, template);
      cancelExport();
    });
  }
}

function downloadTemplate(selectedTemplate){
  Client.get(`template?name=${selectedTemplate}.xlsx`, {host}).then((res)=>{
    loadTemplate(res.data, selectedTemplate)
  })
}

function getExport(key, filename){
  Client.get(`report/bidataexport/${key}`).then(res => {
    return res.text();
  }).then(x => {
    let blob = new Blob([x]);
    let a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = `${filename}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  })
}

async function deleteExport(key){
  return await Client.del(`report/bidataexport/${key}`)
}

function loadTemplate(uri:string, name:string):void {
  let a = window.document.createElement('a');
  a.href = uri;
  a.download = name + ".xlsx";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  cancelExport();
}

function cancelExport():void {
  exportStream.next({...initialState});
}

// public module interface //

const exportService = {
  stream: () => exportStream.asObservable(),
  value: () => exportStream.getValue(),
  cancelExport: () => cancelExport(),
  biDataExport: (payload:object) => biDataExport(payload),
  exportFile: (template:string, properties:object[]|undefined|null, chartid:string|null) => exportFile(template, properties, chartid),
  exportFileCb: (template:string, chartid:string|null) => exportFileCb(template, chartid),
  deleteExport,
  downloadTemplate,
  getBIDataExports,
  getExport
  
}

export default exportService
